<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        <form [formGroup]="webForm">
            <div fxLayout="row wrap" fxLayout.lt-sm="column">
                <div fxFlex="100" class="pr-1"><br></div>
                    <div fxFlex="100" class="pr-1">
                      <mat-checkbox name="app" [formControl]="webForm.controls['app']">Aplicativo ? </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">
                        <mat-checkbox name="lojaOnline" [formControl]="webForm.controls['lojaOnline']">Loja Online ? </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaRemota" [formControl]="webForm.controls['empresaRemota']">Empresa remota ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="servidorLocal" [formControl]="webForm.controls['servidorLocal']">Servidor Local ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaTransporte" [formControl]="webForm.controls['empresaTransporte']">Empresa Módulo Transportadora (Emissão CT-e) ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaMDFe" [formControl]="webForm.controls['empresaMDFe']">Empresa Módulo Manifesto de Carga (Emissão MDF-e) ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">
                      <mat-checkbox name="empresaPontoAtendimento" [formControl]="webForm.controls['empresaPontoAtendimento']">Empresa Módulo Ponto de Atendimento (Mapa Pontos de Atendimento) ?
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaServicosMecanico" [formControl]="webForm.controls['empresaServicosMecanico']">Empresa Módulo Serviços Mecânico (Ordem de Serviço)? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaConsultoria" [formControl]="webForm.controls['empresaConsultoria']">Empresa Módulo Consultoria e Serviços Jurídico ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1">  
                      <mat-checkbox name="empresaAutomacao" [formControl]="webForm.controls['empresaAutomacao']">Empresa Módulo Automação Industrial ? 
                      </mat-checkbox>
                    </div>
                    <div fxFlex="100" class="pr-1"><br></div>
                    <div fxFlex="100" class="pr-1">
                      <mat-form-field class="full-width" *ngIf="webForm.controls['empresaRemota'].value">
                        <input matInput type="text" name="filialApi" [formControl]="webForm.controls['filialApi']"
                          placeholder="Filial na empresa remota">
                      </mat-form-field>

                      <mat-form-field class="full-width" *ngIf="webForm.controls['empresaRemota'].value">
                        <input matInput type="text" name="filialAccessApi" [formControl]="webForm.controls['filialAccessApi']"
                          placeholder="Filtro de Filiais" [matTooltip]="'Digite as filiais a serem consultadas'">
                      </mat-form-field>

                      <mat-form-field class="full-width">
                        <input matInput type="text" name="urlApi" [formControl]="webForm.controls['urlApi']"
                          placeholder="url da api">
                      </mat-form-field>
                      <small *ngIf="webForm.controls['urlApi'].hasError('required') && webForm.controls['urlApi'].touched" class="form-error-msg"> Campo obrigatório </small>
            
                      <mat-form-field class="full-width">
                        <input matInput type="text" name="urlFotoLoja" [formControl]="webForm.controls['urlFotoLoja']"
                          placeholder="Logotipo/Foto da Loja">
                        <img *ngIf="webForm.controls['urlFotoLoja']" [src]="webForm.controls['urlFotoLoja'].value">
                      </mat-form-field>
                      <small *ngIf="webForm.controls['urlApi'].hasError('required') && webForm.controls['urlApi'].touched" class="form-error-msg"> Campo obrigatório </small>
            
                      <mat-form-field class="full-width">
                        <input matInput type="text" name="urlLogo" [formControl]="webForm.controls['urlLogo']"
                          placeholder="Logotipo da Loja">
                        <img *ngIf="webForm.controls['urlLogo']" [src]="webForm.controls['urlLogo'].value">
                      </mat-form-field>
                      <small *ngIf="webForm.controls['urlLogo'].hasError('required') && webForm.controls['urlLogo'].touched" class="form-error-msg"> Campo obrigatório </small>
                    </div>
            </div>
        </form>
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
            (click)="this.save();$event.preventDefault();"><mat-icon>save</mat-icon>{{"SAVE" |
            translate }}
        </button>
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()"><mat-icon>close</mat-icon>{{"CLOSE" | translate }}</button>
    </div>
</mat-dialog-actions>

